/* eslint-disable no-bitwise */
import type { Tournament } from '@ps/web-poker-types';
import { TournFlags, TournFlags2, TournMask } from '@ps/web-poker-types';

export const isPrivate = (tournMask: Tournament['TOURNMASK']): boolean =>
  Boolean(tournMask & TournMask.TOURNEY_PRIVATE);

export const isSitgo = (tournFlags: Tournament['TOURNFLAGS']): boolean =>
  Boolean(tournFlags & TournFlags.TOURNSCRIPT_FLAG_SITANDGO);

export const isSitShootout = (tournFlags: Tournament['TOURNFLAGS']): boolean =>
  Boolean(tournFlags & TournFlags.TOURNSCRIPT_FLAG_OLYMPICHACK);

export const isSpingo = (tournFlags2: Tournament['TOURNFLAGS2']): boolean =>
  Boolean(tournFlags2 & TournFlags2.TOURNSCRIPT_FLAG2_SPINANDGO);

export const isSpinMax = (tournFlags2: Tournament['TOURNFLAGS2']): boolean =>
  Boolean(tournFlags2 & TournFlags2.TOURNSCRIPT_FLAG2_SPINANDGOMAX);

export const hasTournamentStarted = (startTimestamp: number, nowTimestamp: number): boolean =>
  startTimestamp !== -1 ? startTimestamp - nowTimestamp < 0 : false;
